import React, { useState, useEffect } from 'react';
import ConfirmDialog from './ConfirmDialog';
import styles from './TriggerReleaseDialog.module.css';
import { createReleasev1 } from '../../api/releases';
import { setAlert } from '../../helpers/alerts';

const ICO_ROCKET = 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09zM12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z';

const ROCKET_ICON_STYLE = {
  background: 'linear-gradient(135deg, #162044, #1570EF)',
  color: '#fff',
  border: 'none',
};

export default function TriggerReleaseDialog({ open, onClose, branch, onTriggered }) {
  const defaultVersion = `${branch?.version}.`;
  const [version,    setVersion]    = useState(defaultVersion);
  const [error,      setError]      = useState('');
  const [triggering, setTriggering] = useState(false);

  useEffect(() => {
    if (open) { setVersion(defaultVersion); setError(''); setTriggering(false); }
  }, [open, defaultVersion]);

  const validate = (v) => /^\d+\.\d+\.\d+/.test(v);

  const handleChange = (e) => {
    const v = e.target.value;
    setVersion(v);
    setError(validate(v) ? '' : `Must match X.Y.Z — e.g. ${defaultVersion}1`);
  };

  const handleConfirm = () => {
    if (!validate(version)) return;
    setTriggering(true);
    createReleasev1({ version, branch_version: branch.version })
      .then((r) => {
        setAlert('Release', `Release ${r.release.version} triggered`, 'success');
        onTriggered?.();
        onClose();
      })
      .catch((err) => {
        setAlert('Release error', err, 'danger');
        setTriggering(false);
      });
  };

  return (
    <ConfirmDialog
      open={open}
      icon={ICO_ROCKET}
      iconStyle={ROCKET_ICON_STYLE}
      title="Trigger release"
      message={`Branch ${branch?.version} · enter the version tag to publish.`}
      confirmLabel="Trigger release"
      confirming={triggering}
      confirmingLabel="Triggering…"
      onConfirm={handleConfirm}
      onCancel={onClose}
    >
      <div className={styles.field}>
        <label className={styles.label}>Version</label>
        <input
          className={`${styles.input}${error ? ` ${styles.inputError}` : ''}`}
          value={version}
          onChange={handleChange}
          autoFocus
          placeholder={`${defaultVersion}1`}
        />
        {error
          ? <span className={styles.hint} style={{ color: 'var(--error-600)' }}>{error}</span>
          : <span className={styles.hint}>Must match X.Y.Z format</span>
        }
      </div>
    </ConfirmDialog>
  );
}
